import Request from "@services/request";
import { IGetAllFormData, IGetSingleFormData } from "./types";

const GetAllWithoutFilter = async () =>
    await new Request().get<IReturnValue<Array<IProducts["get"]>>>(
        "PRODUCTS_ALL",
    );

const GetAll = async ({ query, page }: IGetAllFormData) =>
    await new Request().get<IReturnValue<Array<IProducts["get"]>>>("PRODUCTS", {
        params: {
            query,
            page,
        },
    });

const GetSingle = async ({ id }: IGetSingleFormData) =>
    await new Request().get<IReturnValue<IProduct["get"]>>({
        base: "PRODUCT",
        params: {
            id,
        },
    });

const Create = async ({
    faName,
    enName,
    seoName,
    url,
    brands,
    categories,
    tags,
    code,
    lcdSize,
    price,
    platformId,
    description,
    seoCanonical,
    seoDescription,
    seoKeywords,
}: IProducts["post"]) =>
    await new Request().post<IProducts["post"], IReturnValue<any>>("PRODUCTS", {
        faName,
        enName,
        seoName,
        url,
        brands,
        categories,
        tags,
        code,
        lcdSize,
        price,
        platformId,
        description,
        seoCanonical,
        seoDescription,
        seoKeywords,
    });

const Edit = async ({
    id,
    faName,
    enName,
    seoName,
    brands,
    categories,
    tags,
    code,
    lcdSize,
    price,
    url,
    platformId,
    description,
    seoCanonical,
    seoDescription,
    seoKeywords,
}: IProduct["put"]) =>
    await new Request().put<Omit<IProduct["put"], "id">, IReturnValue<any>>(
        {
            base: "PRODUCT",
            params: {
                id,
            },
        },
        {
            faName,
            enName,
            seoName,
            brands,
            categories,
            tags,
            code,
            lcdSize,
            price,
            url,
            platformId,
            description,
            seoCanonical,
            seoDescription,
            seoKeywords,
        },
    );

const Delete = async ({ id }: IProduct["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "PRODUCT",
        params: {
            id,
        },
    });

const UploadFile = async ({ id, file }: { id: number; file: File }) => {
    const formData = new FormData();

    formData.append("image", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >(
        {
            base: "PRODUCT_IMAGE",
            params: {
                id,
            },
        },
        formData,
    );
};

const DeleteImage = async ({ id }: IProduct["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "PRODUCT_IMAGE",
        params: {
            id,
        },
    });

const Publish = async ({ id }: IProduct["delete"]) =>
    await new Request().post<{}, IReturnValue<any>>(
        {
            base: "PRODUCT_PUBLISH",
            params: {
                id,
            },
        },
        {},
    );

const GetExcel = async () =>
    await new Request().get<any>("PRODUCT_EXCEL", {
        responseType: "blob",
    });

const UploadExcel = async ({ file }: { file: File }) => {
    const formData = new FormData();

    formData.append("file", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >("PRODUCT_EXCEL", formData);
};

// Main Object
const ProductsApis = {
    GetAllWithoutFilter,
    GetAll,
    GetSingle,
    Create,
    Edit,
    Delete,
    UploadFile,
    DeleteImage,
    Publish,
    GetExcel,
    UploadExcel,
};

export default ProductsApis;
